import Icon from 'veui/components/Icon'
import { IconMinus } from 'dls-icons-vue'

Icon.register('minus', IconMinus)
